import React, {Component} from "react";
import {Col, Radio, Row} from "antd";
import {TIRE_TYPE_SUMMER, TIRE_TYPE_WINTER} from "../../definition/business";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import carDrawing from "../../../../img/cuiImg/car-drawing.png";
import SAInputNumber from "../../../../components/common/input/SAInputNumber";
import Checkbox from "./Checkbox";

class TireReplacement extends Component {

  componentWillMount(){
    const {selectedDealer} = this.props;
    this.props.dispatchFetchTireBrands({ dealerId: selectedDealer.id });

  }
  onSelectTireType = selectedTireType => {
    this.props.dispatchSaveTireReplacement({selectedTireType});
  };
  onSelectedTire = (value, evt) => {
    this.props.dispatchSaveTireReplacement({[evt.target.id]:value});
  };
  onTireWidthChange = tireWidth => {
    this.props.dispatchSaveTireReplacement({tireWidth});
  };
  onTireProfileChange = tireProfile => {
    this.props.dispatchSaveTireReplacement({tireProfile});
  };
  onTireDiameterChange = tireDiameter => {
    this.props.dispatchSaveTireReplacement({tireDiameter});
  };


  handleSelectTires = (checked, evt) => {
    const {tireReplacement={}} = this.props;
    const selectedTiresBrands = tireReplacement.selectedTiresBrands || [];
    const selectedBrand = evt.target.id;
    const index = selectedTiresBrands.findIndex(b => b === selectedBrand);
    if (checked){
      if (index === -1) {
        selectedTiresBrands.push(selectedBrand);
      }
    } else {
      selectedTiresBrands.splice(index, 1);
    }
    this.props.dispatchSaveTireReplacement({selectedTiresBrands});
  }

  render() {
    const {intl: {formatMessage}, tireReplacement={}, brands} = this.props;

    const {selectedTireType, selectedTiresBrands=[],
      selectedFrontLeftTire, selectedFrontRightTire, selectedBackLeftTire, selectedBackRightTire,
      tireWidth, tireProfile, tireDiameter} = tireReplacement;

    return <div type="flex" style={{ marginLeft: '3rem'}}>
      <Row type="flex" style={{margin: 'auto', width: '100%', paddingBottom: 25}}>
        <Col span={24}>
          {formatMessage({id: 'customer.journey.step.serviceMobility.tireReplacement.typeTitle'})}
        </Col>
        <Col span={24}>
          <Radio checked={selectedTireType === TIRE_TYPE_SUMMER} onClick={e => this.onSelectTireType(TIRE_TYPE_SUMMER)}>
            {formatMessage({id: 'customer.journey.step.serviceMobility.tireReplacement.typeSummer'})}
          </Radio>
          <Radio checked={selectedTireType === TIRE_TYPE_WINTER} onClick={e => this.onSelectTireType(TIRE_TYPE_WINTER)}>
            {formatMessage({id: 'customer.journey.step.serviceMobility.tireReplacement.typeWinter'})}
          </Radio>
        </Col>
      </Row>
      <Row type="flex" style={{margin: 'auto', width: '100%', paddingBottom: 25}}>
        <Col style={{ paddingBottom: 20 }} span={24}>
          {formatMessage({id: 'customer.journey.step.serviceMobility.tireReplacement.tirePositionTitle'})}
        </Col>
        <Col span={12} xs={24} sm={24} md={24} lg={24} xl={12} xxl={12} style={{margin: 'auto', justifyContent: 'center'}}>
          <div style={{ position: 'relative', width: 200, height: 400 }}>
            <img src={carDrawing} style={{width: '100%', height: '100%'}} alt={"Car drawing"}/>
            <Checkbox
              aria-label={"Select front left tire"}
              id="selectedFrontLeftTire"
              checked={selectedFrontLeftTire}
              onChange={this.onSelectedTire}
              labelStyle={{ position: 'absolute', top: -350, left: -20 }}
            >&nbsp;</Checkbox>
            <Checkbox
              aria-label={"Select front right tire"}
              id="selectedFrontRightTire"
              checked={selectedFrontRightTire}
              onChange={this.onSelectedTire}
              labelStyle={{ position: 'absolute', top: -360, right: -28 }}
            >&nbsp;</Checkbox>
            <Checkbox
              aria-label={"Select back left tire"}
              id="selectedBackLeftTire"
              checked={selectedBackLeftTire}
              onChange={this.onSelectedTire}
              labelStyle={{ position: 'absolute', bottom: 60, left: -20 }}
            >&nbsp;</Checkbox>
            <Checkbox
              aria-label={"Select back right tire"}
              id="selectedBackRightTire"
              checked={selectedBackRightTire}
              onChange={this.onSelectedTire}
              labelStyle={{ position: 'absolute', bottom: 60, right: -28, margin: 0 }}
            >&nbsp;</Checkbox>
          </div>
        </Col>
      </Row>
      <Row span={12} xs={24} sm={24} md={24} lg={24} xl={12} xxl={12} style={{margin: 'auto', width: '100%', paddingBottom: 25}}>
        {brands && brands.length > 0 && (
          <Col span={24} >
            <Row style={{ paddingBottom: 20 }}>
              {formatMessage({id: 'customer.journey.step.serviceMobility.tireReplacement.chooseBrandsTitle'})}
            </Row>
            <Row style={{ paddingLeft: 25 }}>
              {brands.map(brand => (
                <Col key={brand}>
                  <Checkbox id={brand} checked={selectedTiresBrands.includes(brand)} onChange={this.handleSelectTires}>
                    {brand}
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </Col>
        )}
        <Col span={24} >
          <Row style={{ paddingBottom: 20 }} span={24}>
            {formatMessage({id: 'customer.journey.step.serviceMobility.tireReplacement.provideSize'})}
          </Row>
          <Row style={{ paddingLeft: 0 }}>
            <Col span={9}>
              <Col span={21}>
                <SAInputNumber
                  aria-label={"Tire width"}
                  value={tireWidth}
                  onChange={this.onTireWidthChange}
                  min={0}
                  max={999}
                />
              </Col>
              <Col span={1}>
                <h2 style={{ width: '100%' }}>/</h2>
              </Col>
            </Col>
            <Col span={9}>
              <Col span={21}>
                <SAInputNumber
                  aria-label={"Tire profile"}
                  value={tireProfile}
                  onChange={this.onTireProfileChange}
                  max={999}
                  min={0}
                />
              </Col>
              <Col span={1}>
                <h2>R</h2>
              </Col>
            </Col>
            <Col span={6}>
              <SAInputNumber
                aria-label={"Tire diameter"}
                value={tireDiameter}
                onChange={this.onTireDiameterChange}
                max={99}
                min={0}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchSaveTireReplacement: params => dispatch({ type: 'SAVE.TIRE_REPLACEMENT', params }),
  dispatchFetchTireBrands: params =>
    dispatch({ type: 'FETCH.CUSTOMER_DEALER_TIRE_BRAND.REQUEST', params }),
});

const mapStateToProps = state => {
  const brands = (state.tireBrands.body && state.tireBrands.body.mainBrands.concat(state.tireBrands.body.extraBrands)) || [];
  return {
    tireReplacement: state.createAppointmentRequest.tireReplacement,
    selectedDealer: state.customerDealer.selectedDealer,
    brands,
}
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TireReplacement)
);




// WEBPACK FOOTER //
// ./src/public/journey1/fragments/services/TireReplacement.js